const STORAGE_KEY = 'excelcar-theme'
const THEME_LIGHT = 'light'
const THEME_DARK = 'dark'

function getStoredTheme() {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch (_err) {
    return null
  }
}

function setStoredTheme(theme) {
  try {
    localStorage.setItem(STORAGE_KEY, theme)
  } catch (_err) {
    // storage might be unavailable (private mode, quota) — ignore silently
  }
}

function getPreferredTheme() {
  const stored = getStoredTheme()
  if (stored === THEME_LIGHT || stored === THEME_DARK) {
    return stored
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? THEME_DARK : THEME_LIGHT
}

function applyTheme(theme) {
  document.documentElement.setAttribute('data-bs-theme', theme)

  document.querySelectorAll('[data-theme-switcher]').forEach((btn) => {
    btn.setAttribute('aria-pressed', theme === THEME_DARK ? 'true' : 'false')
    btn.dataset.currentTheme = theme
  })
}

function initThemeSwitcher() {
  applyTheme(getPreferredTheme())

  document.querySelectorAll('[data-theme-switcher]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const current = document.documentElement.getAttribute('data-bs-theme') === THEME_DARK
        ? THEME_DARK
        : THEME_LIGHT
      const next = current === THEME_DARK ? THEME_LIGHT : THEME_DARK

      applyTheme(next)
      setStoredTheme(next)
    })
  })

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
    if (getStoredTheme()) {
      return
    }
    applyTheme(e.matches ? THEME_DARK : THEME_LIGHT)
  })
}

// apply stored theme ASAP to limit FOUC, even before DOM is ready
applyTheme(getPreferredTheme())

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initThemeSwitcher)
} else {
  initThemeSwitcher()
}
